import styled from 'styled-components'

export const HeadTable = styled.h3`
  font-size: 1.5rem;
  font-weight: 500;
  span:first-child {
    text-align: center;
  }
`

export const Container = styled.div`
  background: ${({ theme }) => theme.colors.black};
  > div,
  > h3 {
    display: grid;
    grid-template-columns: 2fr repeat(2, 1fr) 2rem;
    align-items: center;
    padding: 1.5% 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.white};
  }

  > :last-child {
    border: none;
    margin-bottom: 0;
  }
  h4 {
    margin-bottom: 0.25rem;
  }

  @media (max-width: 596px) {
    > h3 {
      display: none;
    }
    > div {
      grid-template-columns: 1fr;
    }
  }

  &:last-child {
    border-radius: 5px;
    padding: 2%;
  }
`

export const Table = styled.div`
  font-size: 1.25rem;
  position: relative;
  img {
    width: 9rem;
    height: 9rem;
  }
  span:first-child {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  span {
    span {
      .price {
        font-size: '1.5rem';
        font-weight: 500px;
      }
    }
  }

  > span:nth-child(2) {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    button {
      background: none;
      border: none;

      display: flex;
      align-items: center;
      justify-content: center;

      color: ${({ theme }) => theme.colors.yellow};
      border: 2px solid;
      border-radius: 50%;
      width: 1.8rem;
      height: 1.8rem;
      font-weight: 500;
      font-size: 1.25rem;
    }
  }

  @media (max-width: 596px) {
    > span:nth-child(1) > span {
      margin-top: -5rem;
    }

    > span:nth-child(2) {
      position: absolute;
      bottom: 3rem;
      left: 10rem;
    }

    > span:nth-child(3) {
      position: absolute;
      bottom: 1rem;
      left: 10.5rem;
    }
  }

  > :last-child {
    width: 100%;
    display: flex;
    justify-content: center;

    button {
      background: none;
      border: none;

      svg {
        fill: ${({ theme }) => theme.colors.yellow};
        width: 1.5rem;
        height: 1.5rem;
      }
    }

    @media (max-width: 596px) {
      position: absolute;
      top: 1rem;
      right: 0;
      justify-content: flex-end;
    }
  }
`
